/** @jsxRuntime classic */
import * as React from "react";
import styled from "@emotion/styled";
import { useStaticQuery, graphql } from "gatsby";
import MDX from "@narative/gatsby-theme-novela/src/components/MDX";
import mediaqueries from "@narative/gatsby-theme-novela/src/styles/media";

interface ResumeProps {
  resumePath?: string;
  authorName: string;
}

const AuthorResume: React.FC<ResumeProps> = ({ resumePath, authorName }) => {
  // Fallback file name for MDX version
  const targetFile = (resumePath?.replace(/^\.\//, "") || "frederic-de-smet-resume.mdx").replace(/\.md$/, ".mdx");

  const data = useStaticQuery(graphql`
    query AuthorResumeMDXOnlyQuery {
      allMdx(filter: { fileAbsolutePath: { regex: "/frederic-de-smet-resume.mdx$/" } }) {
        nodes { body fileAbsolutePath }
      }
    }
  `);

  const mdxNode = data.allMdx?.nodes?.find((n: any) => n.fileAbsolutePath.endsWith(targetFile));
  if (!mdxNode) return null;

  return (
    <ArticleBody id="author-resume">
      <MDX content={mdxNode.body} />
    </ArticleBody>
  );
};

export default AuthorResume;

const ArticleBody = styled.section`
  position: relative;
  /* Match article left gutter but reduce top space since hero already took vertical space */
  padding: 80px 0 35px;
  padding-left: 68px;
  transition: background 0.2s linear;

  ${mediaqueries.desktop_medium`padding:70px 0 35px;`}
  ${mediaqueries.desktop`padding:60px 0 35px; padding-left:53px; background:transparent; border-radius:0;`}
  ${mediaqueries.tablet`padding:50px 0 60px; padding-left:0;`}
  ${mediaqueries.phablet`padding:45px 0 55px;`}
`;

const ResumeTitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  font-family: ${(p: any) => p.theme.fonts.serif};
  line-height: 1.32;
  margin: 0 auto 55px;
  color: ${(p: any) => p.theme.colors.primary};
  width: 100%;
  max-width: 680px;
  ${mediaqueries.desktop`max-width:507px;`}
  ${mediaqueries.tablet`font-size:36px; margin:0 auto 45px; max-width:486px;`}
  ${mediaqueries.phablet`font-size:32px; margin:0 auto 40px; padding:0 20px;`}
`;

// Removed intermediate wrappers; MDX component handles centering + widths.
const ResumeBody = styled.article``;

// Outer to mirror MDXBody flex + centering
const ContentOuter = styled.div``;

const Content = styled.div``;
